import { updatingTrueTime } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';
import setAccountPendingTrueTimeUpdateMutator from '../mutators/setAccountPendingTrueTimeUpdateMutator';
import setTrueTimeUpdateFailedAccountMutator from '../mutators/setTrueTimeUpdateFailedAccountMutator';

orchestrator(updatingTrueTime, async actionMessage => {
    if (actionMessage.userIdentity) {
        // actionMessage.userIdentity not null indicates we are not starting the update,
        // hence clear the error message while we wait for a response
        setTrueTimeUpdateFailedAccountMutator(null);
    }

    // Show the spinner while waiting for a response from the server
    setAccountPendingTrueTimeUpdateMutator(actionMessage.userIdentity);
});
